@if (project && projectEditForm) {
  <div class="hub-edit-outcomes-container">
    <div class="outcomes-list-panel hub-custom-scrollbar">
      <div class="outcomes-list-header-panel">
        <h5 class="edit-section-header">{{project.projectType.name }} Outcomes
          ({{project.projectOutcomes.length}})<app-help-selector [selector]="1187">
        </app-help-selector>
      </h5>
      @if (!isWholeSystem) {
        <button
          class="btn-outline bg-primary-300 text-primary btn-icon btn rounded-round ml-2"
          (click)="openCreateOutcomeDialog(null)" tabindex="0">
          <i class="icon-plus-circle2 mr-2"></i> Create Outcome
        </button>
      }
    </div>
    @if (!project.projectOutcomes?.length) {
      <div class="p-2 pl-3">
        <div class="d-block alert alert-info alert-styled-left shadow-0">
          There are no outcomes defined yet.
        </div>
      </div>
    }
    <div class="outcomes-list section-list" id="lstResults">
      @if (outcomes.length) {
        <h6 class="organizational-metrics-heading">
          2030 Goals Metrics
          <app-help-selector [selector]="1186"></app-help-selector>
        </h6>
      }
      <div cdkDropList (cdkDropListDropped)="outcomeReordered($event)">
        @for (outcome of outcomes; track outcome) {
          <app-outcome-display [projectOutcome]="outcome" [hubRecord]="project"
            outcomeType="outcome" (click)="selectProjectOutcome(outcome)"
            (deleteOutcomeRequested)="deleteProjectOutcomeRequested(outcome)" cdkDrag
            class="org-metric-sca-outcome-list" (editOutcomeRequested)="openEditOutcomeDialog($event)"
            [isSelected]="outcome === selectedProjectOutcome">
          </app-outcome-display>
        }
      </div>
      @if (customOutcomes.length) {
        <h6 class="non-sca-metrics-heading">
          Custom Metrics
          <app-help-selector [selector]="1189"></app-help-selector>
        </h6>
      }
      <div cdkDropList (cdkDropListDropped)="customOutcomeReordered($event)">
        @for (customOutcome of customOutcomes; track customOutcome) {
          <app-custom-outcome-display
            [projectOutcome]="customOutcome" (click)="selectProjectOutcome(customOutcome)"
            (deleteOutcomeRequested)="deleteProjectOutcomeRequested(customOutcome)" cdkDrag
            class="non-sca-outcome-list" (editOutcomeRequested)="openEditOutcomeDialog($event)"
            [isSelected]="customOutcome === selectedProjectOutcome">
          </app-custom-outcome-display>
        }
      </div>
    </div>
  </div>
  @if (selectedProjectOutcome) {
    <div class="outcome-detail-container project-edit-items-details">
      <app-outcome-details [projectOutcome]="selectedProjectOutcome"></app-outcome-details>
    </div>
  }
</div>
}
